<template>
    <main class="tw-flex tw-min-h-screen tw-flex-col md:tw-flex-row">
        <div 
            v-if="isSidebarCollapsed === false && isMobile"
            class="tw-fixed tw-inset-0 tw-bg-black/50 tw-z-[1000]"
            @click="toggleSidebar"
        />
        
        <SideBar :is-collapsed="isSidebarCollapsed" :is-mobile="isMobile" />
        
        <div class="tw-flex tw-flex-col tw-flex-1" :class="['pagev2', { active: isSidebarCollapsed }, { 'md:tw-ml-72': !isSidebarCollapsed && !isMobile }, { 'md:tw-ml-24': isSidebarCollapsed && !isMobile }]">
            <NavBar />
            <div :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-flex-1 tw-min-w-0">
                <slot></slot>
            </div>
            <FooTer />
        </div>
    </main>
</template>

<script>
import { mapState, mapActions, useStore } from 'vuex';
import { ref, onMounted, onUnmounted } from 'vue';
import FooTer from "../../ui/v2/FooTer.vue";
import NavBar from "../../ui/v2/NavBar.vue";
import SideBar from "../../ui/v2/SideBar.vue";

export default {
    name: "MainLayout",
    components: {
        SideBar,
        NavBar,
        FooTer,
    },
    setup() {
        const store = useStore();
        const isMobile = ref(false);
        const isMobileMenuOpen = ref(false);

        const checkMobile = () => {
            const eraMobile = isMobile.value;
            isMobile.value = window.innerWidth < 1000;

            if (isMobile.value && !eraMobile && !store.state.ui.isSidebarCollapsed) {
                store.commit('ui/TOGGLE_SIDEBAR');
            }
        };

        onMounted(() => {
            checkMobile();
            window.addEventListener('resize', checkMobile);
        });

        onUnmounted(() => {
            window.removeEventListener('resize', checkMobile);
        });

        return {
            isMobile,
            isMobileMenuOpen
        };
    },
    computed: {
        ...mapState('ui', ['isSidebarCollapsed']),
        ...mapState({
            theme: state => state.ui.theme,
        }),
        
    },
    methods: {
        ...mapActions('ui', ['toggleSidebar']),
    }
};
</script>
<style scoped>main {
    width: 100%;
    overflow-x: clip;
}

.pagev2 {
    min-height: 100vh;
    padding-bottom: 0;
    width: 100%;
    flex: 1 1 auto;
}

@media (max-width: 999px) {
    .pagev2 {
        margin-left: 0;
        width: 100%;
        padding-top: 56px;
    }
}

@media (min-width: 1000px) {
    .pagev2 {
        width: calc(100% - 288px);
    }

    .pagev2.active {
        width: calc(100% - 96px);
    }
}
</style>
